/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CircularContent } from '../../models/circular-content';
import { CircularContentApiRespModel } from '../../models/circular-content-api-resp-model';

export interface ApiMasterCircularContentEditPost$Params {
      body?: CircularContent
}

export function apiMasterCircularContentEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterCircularContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CircularContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCircularContentEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CircularContentApiRespModel>;
    })
  );
}

apiMasterCircularContentEditPost.PATH = '/api/Master/CircularContent/Edit';
